<template>
  <v-container fluid class="fill-height">
    <k-nodata-info>
      <template v-slot:icon>
        <i class="fas fa-exclamation"></i>
      </template>
      <template v-slot:title>
        {{ nyelvesites['nincs_token_text'] }}
      </template>
    </k-nodata-info>
    <!-- <div>
      <pre v-for="(message, index) in errorMessages" :key="index">{{
        message
      }}</pre>
    </div> -->
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { errorMessages } from '../main';
import { AppStoreTypes } from '../store/modules/app';
export default {
  name: 'no-permission',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
    // errorMessages() {
    //   console.log(errorMessages.value);
    //   return errorMessages.value;
    // },
  },
  watch: {},
};
</script>
